import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useCustomerAuth } from './CustomerAuthContext';

// Wraps customer-only routes (dashboard, profile, booking detail, tow
// vehicle edit). Redirects unauthenticated users to /account/login with
// a `next` query param so they land back here after signing in.
function RequireCustomerAuth({ children }) {
  const { customer, token, loading } = useCustomerAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <p style={{ color: '#64748b' }}>Loading…</p>
      </div>
    );
  }

  if (!token || !customer) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/account/login?next=${next}`} replace />;
  }

  return children;
}

export default RequireCustomerAuth;
